// @flow
// import "react-app-polyfill/ie9";
// import "@babel/polyfill";
//react
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import "./css/main.scss";

ReactDOM.render(<App />, document.getElementById("root"));
